import { FEEDBACKS } from "constants/types"
import { formData, authApi } from "utils"
import { setPermission } from "services/common/actions";


export const getFeedback = () => (dispatch) => {
	return authApi.get(`self/feedback`).then(res => {
		if (res.status === 200) {
			dispatch({
				type: FEEDBACKS.FEEDBACKS,
				payload: res.data.feedback
			})
			return res
		} else if (res.status === 401) {
			dispatch(setPermission(false))
			return null
		} else {
			throw res
		}
	})
		.catch(err => {
			throw err
		})
}

export const createAppeal = (data) => () => {
	return authApi.post(`feedback/appeals/create`, formData(data)).then(res => {
		if (res.status === 200) {
			return res
		} else {
			throw res
		}
	})
		.catch(err => {
			throw err
		})
}

export const getAppeals = () => () => {
	return authApi.get(`self/feedback/appeals`)
		.then(res => {
			if (res.status === 200) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
}


export const getFeedbackById = (id) => (dispatch) =>
	authApi.get(`/feedback/unique/${id}`)
		.then(res => {
			if (res.status === 200) {
				dispatch({
					type: FEEDBACKS.CURRENT_FEEDBACK,
					payload: res.data.feedback
				})
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})

export const replyFeedback = (feedback) => () =>
	authApi.post(`/feedback/reply`, formData(feedback))
		.then(res => {
			if (res.status === 200) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})


